import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "../styles/Home.css";

function HomePage() {

    const [t, i18n] = useTranslation("global");
    //text = t("home.text");

    
    // Objeto con los enlaces dinámicos
    const dynamicLinks = {
        "{SOCO}": <a href="https://soco.upc.edu/en" >SOCO</a>,
        "{UPC}": <a href="https://www.upc.edu" >UPC</a>,
        "{GREC}": <a href="https://www.fib.upc.edu/ca/recerca/grups-de-recerca/grec-grup-de-recerca-en-enginyeria-del-coneixement">GREC</a>,
        "{PERMEPSY}": <a href="https://permepsy.org/">PERMEPSY</a>,
        "{FSJD}": <a href="https://www.irsjd.org/es/investigacion/32/etiopatogenia-y-tratamiento-de-los-trastornos-mentales-graves-meritt">FSJD</a>,
        "{UKE}": <a href="https://clinical-neuropsychology.de/our_research_team/">UKE</a>,
        "{Inserm}": <a href="https://www.inserm.fr/en/home/">Inserm</a>,
        "{PAoS}": <a href="https://psych.pan.pl/instytut-psychologii-pan/">PAoS</a>,
        "{UV}": <a href="https://psiquiatria.uv.cl/equipo">UV</a>
    };
    
    // Función que reemplaza las palabras clave por los enlaces correspondientes
    const replaceDynamicLinks = (text) => {
        // Divide el texto por todas las claves dinámicas encontradas
        const parts = text.split(/({.*?})/g); // Expresión regular para capturar claves como {UPC}, {MIT}, etc.

        // Mapea cada parte, reemplazando las claves con los enlaces si existen
        return parts.map((part, index) => {
            if (dynamicLinks[part]) {
                return <span key={index}>{dynamicLinks[part]}</span>;
            }
            return <span key={index}>{part}</span>; // Si no es clave, devolver el texto normal
        });
    };
    
    const textWithLinks = t("home.text"); 
    
    return (
        <>
            <Row>
                <Col>
                    <div className="container-text">
                        <h1 className="mt-5 mb-5">{t("home.title")}</h1>
                        <p>{replaceDynamicLinks(textWithLinks)}</p>
                        <p><i>{t("home.warningAI")}</i></p>
                    </div>
                </Col>
                <Col>
                    <div className="img-background">
                        <img src="/home-img.svg" />
                    </div>
                </Col>
            </Row>
        </>
    );
}
export default HomePage;
